import { MAX_STYLE_TEMPLATE_IMAGES } from 'schemas';

export const styleTemplateFormMessages = {
  formAriaLabel: 'Style template creation form',
  titleLabel: 'Title',
  titlePlaceholder: 'Enter style template title',
  descriptionLabel: 'Description',
  descriptionPlaceholder:
    'Enter a detailed description of this style template...',
  imagesLabel: 'Style Images',
  imagesDescription: `Upload up to ${MAX_STYLE_TEMPLATE_IMAGES} images that represent this style (optional)`,
  imageUploadPlaceholder: 'Click to upload images',
  imageUploadSupportedFormats: 'Supports: JPG, PNG, GIF, WebP',
  imageUploadClickToChange: 'Click to change images',
  maxImagesReached: `Maximum ${MAX_STYLE_TEMPLATE_IMAGES} images reached`,
  addImageButton: 'Add Image',
  removeImageButton: 'Remove',
  createTemplateButton: 'Create Style Template',
  creating: 'Creating...',
} as const;
